const filterOptions = [
    {
        label: 'i18n_filter_equals',
        type: 'eq',                
        pillText:(name,{value})=> `${name} = '${value}'`
    },
    {
        label: 'i18n_filter_not_equals',
        type: 'neq',        
        pillText:(name,{value})=> `NOT ${name} = '${value}'`
    },
    {
        label: 'i18n_filter_contains',
        type: 'contains',                
        pillText:(name,{value})=> `${name} contains '${value}'`
    },
    {
        label: 'i18n_filter_not_contains',
        type: 'ncontains',
        pillText:(name,{value})=> `NOT ${name} contains '${value}'`
    },
    {
        label: 'i18n_filter_starts_with',
        type: 'startsWith',
        // function: (x,y) => x.startsWith(y),
        inputAmount: 1,
        pillText:(name,{value})=> `${name} starswith '${value}'`
    },
    {
        label: 'i18n_filter_not_starts_with',
        type: 'nstartsWith',        
        pillText:(name,{value})=> `NOT ${name} startswith '${value}'`
    },
    {
        label: 'i18n_filter_ends_with',
        type: 'endsWith',        
        pillText:(name,{value})=> `${name} endswith ${value}`
    },
    {
        label: 'i18n_filter_not_ends_with',
        type: 'nendsWith',                
        pillText:(name,{value})=> `NOT ${name} endswith ${value}`
    },
    {
        label: 'i18n_filter_greater_than',
        type: 'gt',
        pillText:(name,{value})=> `${name} > ${value}`
    },
    {
        label: 'i18n_filter_not_greater_than',
        type: 'ngt',        
        pillText:(name,{value})=> `NOT ${name} > ${value}`
    },
    {
        label: 'i18n_filter_greater_than_or_equal',
        type: 'gte',
        pillText:(name,{value})=> `${name} >= ${value}`                
    },
    {
        label: 'i18n_filter_not_greater_than_or_equal',
        type: 'ngte',
        pillText:(name,{value})=> `NOT ${name} >= ${value}`
    },
    {
        label: 'i18n_filter_lesser_than',
        type: 'lt',        
            pillText:(name,{value})=> `${name} < ${value}`
    },
    {
        label: 'i18n_filter_not_lesser_than',
        type: 'nlt',        
        pillText:(name,{value})=> `NOT ${name} < ${value}`        
    },
    {
        label: 'i18n_filter_lesser_than_or_equal',
        type: 'lte',        
        pillText:(name,{value})=> `${name} <= ${value}`        
    },
    {
        label: 'i18n_filter_not_lesser_than_or_equal',
        type: 'nlte',
        pillText:(name,{value})=> `NOT ${name} <= ${value}`        
    },
    {
        label: 'i18n_filter_between',
        type: 'between',
        inputAmount: 2,
        pillText:(name,{value,value2})=> `${name} between ${value} and ${value2}`
    },
    {
        label: 'i18n_filter_not_between',
        type: 'nbetween',
        pillText:(name,{value,value2})=> `NOT ${name} between ${value} and ${value2}`
    },
    {
        label: 'i18n_filter_from',
        type: 'from',
        pillText:(name,{value,value2})=> `${name} between and include ${value} and ${value2}`
    },
    {
        label: 'i18n_filter_not_from',
        type: 'nfrom',
        pillText:(name,{value,value2})=> `NOT ${name} between and include ${value} and ${value2}`
    },
]
// const listFilterOptions = [
//     {
//         label: 'i18n_list_filter_all',
//         type: 'all',
        
//     }
// ]

const GetFilterDropdown = dataType => {
    let filterArray;
    // let listFilterArray = false;
    switch (dataType) {
        case 'String':
        case 'String[]': filterArray = ['eq','neq','contains','ncontains','startsWith','nstartsWith','endsWith','nendsWith']; break
        case 'Byte': 
        case 'Sbyte': 
        case 'Short': 
        case 'Ushort': 
        case 'Integer': 
        case 'Uinteger': 
        case 'Long': 
        case 'Ulong': 
        case 'Float': 
        case 'Double': 
        case 'Decimal': filterArray = ['eq','neq','gt','ngt','gte','ngte','lt','nlt','lte','nlte','between','nbetween','from','nfrom']; break
        case "DateTime": filterArray=["eq","gt","gte","in","lt","lte","neq","ngt","ngte","nin","nlt","nlte"]; break;
        case 'Boolean': filterArray = ['eq','neq']; break
        default: filterArray = []; break
    }
    const availableFilters = []
    filterArray.forEach(x => {
        const correspondingOption = filterOptions.find(y => y.type === x)
        if (correspondingOption) {
            availableFilters.push(correspondingOption)
        }
    })
    return availableFilters
}

export default GetFilterDropdown
export {filterOptions}
